import { Timestamp } from "@firebase/firestore";

export type UserStatusType = 'pending_approval' | 'approved' | 'rejected' | 'disabled'; // | 'banned'

/**
 * Firestore users 컬렉션의 User 문서 인터페이스
 */
export interface User {
  uid: string;
  email: string;
  displayName: string;
  phoneNumber: string;
  isEnterpriseUser: boolean;
  enterpriseId: string | null;
  createdAt: Timestamp;
  termsAgreed: {
    required: boolean;
    optional: boolean;
  };
  role: 'user' | 'admin';
  status: UserStatusType;
}

/**
 * Firestore user/{uid}/device 하위 컬렉션의 Device 문서 인터페이스
 */
export interface Device {
  fcmToken: string;
  platform: 'android' | 'ios';
  lastUsed: Timestamp;
}

/**
 * Firestore user/{uid}/event 하위 컬렉션의 Event 문서 인터페이스
 */
export interface UserEvent {
  eventId?: string; // 문서 ID로 사용되므로 optional
  participatedAt: Timestamp;
}

/**
 * Firestore user/{uid}/notifications 하위 컬렉션의 UserNotification 문서 인터페이스
 */
export interface UserNotification {
  notificationId: string;
  receivedAt: Timestamp;
  isRead: boolean;
}

/**
 * Firestore devices 상위 컬렉션의 AnonymousDevice 문서 인터페이스 (익명 유저용)
 */
export interface AnonymousDevice {
  deviceId: string;
  fcmToken: string;
  platform: 'android' | 'ios';
  model: string | null;
  lastUsed: Timestamp;
  createdAt: Timestamp;
}

/**
 * User 컬렉션 경로 상수
 */
export const USER_COLLECTION = process.env.REACT_APP_USER_COLLECTION as string;

/**
 * User 컬렉션 경로 상수
 */
export const ENTERPRISE_COLLECTION = process.env.REACT_APP_ENTERPRISE_COLLECTION as string;

/**
 * Device 하위 컬렉션 경로 상수
 */
export const DEVICE_SUBCOLLECTION = process.env.REACT_APP_DEVICE_COLLECTION as string;

/**
 * Event 하위 컬렉션 경로 상수
 */
export const USER_EVENT_SUBCOLLECTION = process.env.REACT_APP_USER_EVENT_COLLECTION as string;

/**
 * Notifications 하위 컬렉션 경로 상수
 */
export const NOTIFICATIONS_SUBCOLLECTION = process.env.REACT_APP_NOTIFICATIONS_COLLECTION as string;

/**
 * Devices 상위 컬렉션 경로 상수 (익명 유저용)
 */
export const DEVICES_COLLECTION = process.env.REACT_APP_DEVICES_COLLECTION as string;



export const UNZIPPEDFILES_COLLECTION = process.env.REACT_APP_UNZIPPEDFILES_COLLECTION as string;
